export default __webpack_public_path__ + "static/media/stopwatch.ee4ff8a4.svg";